//
//
//
//
//
//
//
//
//
//

  export default {
    props: {
      gameType: {
        type: String,
        require: true
      },
      gameList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {}
    },
    methods: {
      handleGoGame(item) {
        const {   platformCode, maintain, maintainRemarks } = item
        if( item.platformCode === 'KingMaker') {  // 如果棋牌,且进入内页
            this.$router.push({ path: '/game/6',  query: { platformCode,maintain,maintainRemarks } })
        }else{
          this.$parent.$parent.$parent._goGame(item)
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/components/game/list-item.vue